module.exports = __webpack_public_path__ + "static/media/eco-ecology-nature-11-svgrepo-com.dfa0f02f.svg";